import React, { useState } from "react";

/// React router dom
import { Link } from "react-router-dom";

/// images
import logo from "../../../images/Logo/Group 10687.svg";
import logoText from "../../../images/Logo/Group 10687.svg";

const NavHader = () => {
   const [toggle, setToggle] = useState(false);
   return (
      <div className="nav-header" style={{zIndex: "12"}}>
         <Link to="/" className="brand-logo">
            {toggle?<img className="logo-abbr" src={logo} alt="" />:<img className="brand-title ml-3" src={logoText} alt="" />}
           
            {/* <img className="logo-compact ml-5" src={logoText} alt="" /> */}
            
         </Link>

         <div className="nav-control" onClick={() => setToggle(!toggle)}>
            <div className={`hamburger ${toggle ? "is-active" : ""}`}>
               <span className="line"></span>
               <span className="line"></span>
               <span className="line"></span>
            </div>
         </div>
      </div>
   );
};

export default NavHader;
